import React from 'react';
import { Card, CardContent, Typography, Stack } from '@mui/material';
import { ArrowDown as ArrowDownIcon } from '@phosphor-icons/react/dist/ssr/ArrowDown';
import { ArrowUp as ArrowUpIcon } from '@phosphor-icons/react/dist/ssr/ArrowUp';

const getKpiArrowIcon = (trend, size) => {
  return trend === 'up' ? (
    <ArrowUpIcon style={{ color: 'green', width: size, height: size }} />
  ) : (
    <ArrowDownIcon style={{ color: 'red', width: size, height: size }} />
  );
};

function KpiElements(kpiData, options = {}) {
  const size = options.size || 'md';
  const isSmall = size === 'sm';
  const titleFontSize = isSmall ? '0.6rem' : '0.9rem';
  const valueFontSize = isSmall ? '1.2rem' : '2rem';
  const diffFontSize = isSmall ? '0.7rem' : '0.875rem';
  const cardWidth = isSmall ? '80%' : '70%';
  const cardPadding = isSmall ? '4px' : '8px';
  const gap = isSmall ? '0.25rem' : '1rem';
  const arrowSize = isSmall ? 14 : 20;

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      gap,
      alignItems: 'center'
    }}>
      {kpiData && Object.keys(kpiData).map((key) => (
        <Card key={key} sx={{
          width: cardWidth,
          height: `${100 / Object.keys(kpiData).length}%`,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <CardContent sx={{ textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', p: cardPadding }}>
            <Typography color="text.secondary" variant="overline" sx={{ fontSize: titleFontSize, fontWeight: 'bold' }}>
              {kpiData[key].title}
            </Typography>
            <Typography sx={{ fontSize: valueFontSize }}>{kpiData[key].value}</Typography>
            <Stack direction="row" spacing={1} alignItems="center">
              {getKpiArrowIcon(kpiData[key].trend, arrowSize)}
              <Typography color={kpiData[key].trend === 'up' ? 'green' : 'red'} variant="body2" sx={{ fontSize: diffFontSize }}>
                {kpiData[key].diff} ({kpiData[key].relative_diff} %)
              </Typography>
            </Stack>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default KpiElements;
